module.exports = __webpack_public_path__ + "media/images/home/plan/option_2-1709cb76cb156328ac713c9e9e2f7112.png";